import { IdentifierDTO } from '@zazume/zzm-base';
import { Language } from '@zazume/zzm-utils';

import { PaginationOptions } from '#/hooks';
import { DocumentTemplate } from '#/models/DocumentTemplate';
import { CustomVariableValues, RequiredRelatedModels } from '#/models/drafts/DraftDocumentCreateRequest';
import { TemplatePreviewResult } from '#/models/template/TemplatePreviewResult';
import { AddTemplateForm } from '#/pages/templates/components/AddTemplateForm.schema';
import { EditTemplateForm } from '#/pages/templates/components/EditTemplateForm.schema';

import { doDelete, doGet, doPost, doPut, EndpointBuilder, toPaginatedURL } from '../../helpers';
import { MergeTag } from './models/MergeTag';

export const documentTemplate = {
  calculatePreviewSettings:
    (id: IdentifierDTO, requiredRelatedModels?: RequiredRelatedModels, customVariableValues?: CustomVariableValues) =>
    () =>
      doPut<TemplatePreviewResult>(`/dashboard/document-template/${id}/preview`, {
        requiredRelatedModels,
        customVariableValues
      }),
  create: (body: AddTemplateForm) => doPost<DocumentTemplate>('/dashboard/document-template/create', body),
  delete: (id: IdentifierDTO) => doDelete(`/dashboard/document-template/${id}`),
  edit: (id: IdentifierDTO) => (body: EditTemplateForm) =>
    doPut<void>(`/dashboard/document-template/${id}/update`, body),
  findPaginated: (params: EndpointBuilder) => (pagination: PaginationOptions) => () =>
    doGet<DocumentTemplate[]>(
      toPaginatedURL(`/dashboard/document-template${params.url}${params.queryParams}`, pagination)
    ),
  getMergeTags: (language: Language) => () =>
    doGet<MergeTag>(`/dashboard/document-template/merge-tags/${language}`, MergeTag.fromRaw),
  getOne: (id: IdentifierDTO) => () => doGet<DocumentTemplate>(`/dashboard/document-template/${id}`)
};
